<div class="row g-4">
  <div class="col-12 col-xl-5">
    <section class="border rounded-4 h-100 p-3 p-lg-4">
      <div class="row g-0 pb-3 mb-3">
        <div class="col-7 fw-bold text-black text-l">{{ selected_document_name }}</div>
      </div>

      <div class="text-dark fw-semibold mb-2 ">Signers</div>
      <article
        v-for="signer in configured_signer_list"
        :key="signer.key || signer.order"
        class="border rounded-4 p-3 mb-3"
      >
        <div class="d-flex align-items-start gap-3">
          <span
            class="configure-signers-avatar rounded-circle d-inline-flex align-items-center justify-content-center text-white fw-bold flex-shrink-0"
            :class="signer.source_type === 'external' ? 'bg-warning' : 'onboarding-bg-navy-dark'"
          >{{ signer.initials || '?' }}</span>
          <div>
            <div class="fw-bold text-black">{{ signer.full_name }}</div>
            <div class="text-muted">{{ signer.email }}</div>
            <div class="text-muted small">{{ signer.role_name }}</div>
          </div>
        </div>
      </article>

      <div v-if="!configured_signer_list.length" class="border rounded-4 p-3 mb-4 text-muted">
        No signer summary is available yet. Go back and complete the signer step first.
      </div>

      <p class="text-muted mb-0">
        {{ notification_copy }}
      </p>
    </section>
  </div>

  <div class="col-12 col-xl-7">
    <section class="rounded-4 h-100">

      <div class="px-3 pb-3">
        <div class="border rounded-4 overflow-hidden bg-light-subtle">
          <div class="border-bottom bg-white px-3 py-3">
            <div class="d-flex align-items-center justify-content-between gap-3 flex-wrap">
              <div class="d-flex align-items-center gap-2 min-w-0">
                <i class="bi bi-file-earmark-text text-muted"></i>
                <span class="text-black">{{ selected_document_name }}</span>
              </div>
              <span class="text-muted small">{{ selected_document_type }}</span>
            </div>
          </div>

          <div class="p-3 p-lg-4">
            <div
              v-if="populated_preview_loading"
              class="document-review-state border bg-white rounded-3 mx-auto p-4 d-flex flex-column align-items-center justify-content-center text-center"
            >
              <div class="spinner-border text-secondary mb-3" role="status" aria-hidden="true"></div>
              <div class="h6 text-black mb-2">Preparing populated preview</div>
              <div class="text-muted">{{ preview_state_copy }}</div>
            </div>
            <div v-else-if="can_render_docuseal_preview" class="document-review-frame border bg-white rounded-3 overflow-hidden">
              <DocusealForm
                :src="populated_preview_form_src"
                :token="populated_preview_token"
                :preview="true"
                :with-download-button="true"
                class="document-review-iframe w-100"
              />
            </div>
            <div v-else-if="review_document_url" class="document-review-frame border bg-white rounded-3 overflow-hidden">
              <iframe
                :key="review_document_url"
                :src="review_document_url"
                class="document-review-iframe w-100"
                frameborder="0"
                title="Selected review document preview"
              ></iframe>
            </div>
            <div v-else-if="preview_launch_url" class="document-review-state border bg-white rounded-3 mx-auto p-4 d-flex flex-column align-items-center justify-content-center text-center">
              <i class="bi bi-file-earmark-text text-muted mb-3"></i>
              <div class="h6 text-black mb-2">Open populated preview</div>
              <div class="text-muted mb-3">{{ preview_state_copy }}</div>
              <button
                type="button"
                class="btn btn-light border btn-sm"
                @click="open_review_document"
              >
                Open in new tab
              </button>
            </div>
            <div v-else class="document-review-state border bg-white rounded-3 mx-auto p-4 d-flex flex-column align-items-center justify-content-center text-center">
              <i class="bi bi-file-earmark-x text-muted mb-3"></i>
              <div class="h6 text-black mb-2">No preview available</div>
              <div class="text-muted">{{ preview_state_copy }}</div>
            </div>

            <div
              v-if="populated_preview_error && selected_document_url"
              class="alert alert-warning mt-3 mb-0"
            >
              Showing the original template because the populated preview could not be loaded. {{ populated_preview_error }}
            </div>
            <div v-else-if="review_document_url" class="d-flex justify-content-end mt-3">
              <button
                type="button"
                class="btn btn-light border btn-sm"
                @click="open_review_document"
              >
                Open in new tab
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
